export default __webpack_public_path__ + "static/media/44375A0D-C85F-4A72-A803-FDE6EBC33693_1_105_c.962edbd2.jpeg";